export const KOREAN_BANKS = {
    KOOKMIN: 'KOOKMIN',
    SHINHAN: 'SHINHAN',
    WOORI: 'WOORI',
    HANA: 'HANA',
    NH_NONGHYEOP: 'NH_NONGHYEOP',
    LOCAL_NONGHYEOP: 'LOCAL_NONGHYEOP',
    IBK: 'IBK',
    KDB: 'KDB',
    CITI: 'CITI',
    SC: 'SC',
    DAEGU: 'DAEGU',
    BUSAN: 'BUSAN',
    GWANGJU: 'GWANGJU',
    JEJU: 'JEJU',
    JEONBUK: 'JEONBUK',
    KYONGNAM: 'KYONGNAM',
    SUHYEOP: 'SUHYEOP',
    SUHYEOP_CENTRAL: 'SUHYEOP_CENTRAL',
    POST: 'POST',
    SAEMAUL: 'SAEMAUL',
    SHINHYEOP: 'SHINHYEOP',
    SANLIM: 'SANLIM',
    SAVING_BANK: 'SAVING_BANK',
    KAKAO_BANK: 'KAKAO_BANK',
    K_BANK: 'K_BANK',
    TOSS_BANK: 'TOSS_BANK',
    HSBC: 'HSBC',
};
export const KOREAN_BANK_VALUES = Object.values(KOREAN_BANKS);
//# sourceMappingURL=korean-banks.js.map